const MyLocalStorage = require("./src/common/utils/MyLocalStorage");
require("./src/styles/global.css");

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    const theme = MyLocalStorage.getTheme() || "dark";
    document.documentElement.setAttribute("data-theme", theme);
  }
};
